import React from 'react';
import { Link } from 'react-router-dom';
import {Plane, Facebook, Twitter, Instagram, Youtube} from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A2540] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 font-bold text-xl mb-4">
              <Plane className="w-6 h-6 text-[#FF6B35]" />
              <span>JE Inform</span>
            </Link>
            <p className="text-gray-400 text-sm">Travel Smarter With Just Enough Information</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Explore</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/destinations" className="hover:text-[#FF6B35] transition-colors">Destinations</Link></li>
              <li><Link to="/attractions" className="hover:text-[#FF6B35] transition-colors">Attractions</Link></li>
              <li><Link to="/tools" className="hover:text-[#FF6B35] transition-colors">Travel Tools</Link></li>
              <li><Link to="/guides" className="hover:text-[#FF6B35] transition-colors">Guides</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/deals" className="hover:text-[#FF6B35] transition-colors">Deals</Link></li>
              <li><Link to="/about" className="hover:text-[#FF6B35] transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-[#FF6B35] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-semibold mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors"><Facebook className="w-5 h-5" /></a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors"><Twitter className="w-5 h-5" /></a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors"><Instagram className="w-5 h-5" /></a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors"><Youtube className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 JE Inform. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
